// Two page widths, no third. Every top-level <main> imports one of these.
//
// PAGE_STANDARD matches the footer's content rail (Actian logo ↔ HCLSoftware
// logo). The header and every list / dashboard / detail / edit page use it.
//
// PAGE_FORM is the narrower rail reserved for simple sign-in, register, and
// book-speaker pages.

// #355: the extra right padding from `lg` up is the HelpButton's clearance.
// That tab is `fixed right-0`, so on a wide viewport it lands on top of the
// content rail. Below `lg` the rail is narrow enough that the tab overlays a
// card's own padding rather than anything you can read, and buying clearance
// there would cost more content width than it is worth.
export const PAGE_STANDARD = 'mx-auto w-full max-w-7xl px-6 lg:pr-12'
export const PAGE_FORM = 'mx-auto w-full max-w-2xl px-4 lg:pr-12'
